import { GpsType } from '../../../../../global/components/layout/layout-models';

export enum WhoWillEnrollOptions {
	member = 'member',
	admin = 'admin',
}

export const memberOrAdminKey = 'memberOrAdmin';


export interface WhoWillEnrollCriterias {
	memberOrAdmin: WhoWillEnrollOptions;
	pension: WhoWillEnrollOptions;
	medical: WhoWillEnrollOptions;
	dental: WhoWillEnrollOptions;
	disability: WhoWillEnrollOptions;
	ltd: WhoWillEnrollOptions;
	std: WhoWillEnrollOptions;
}

export interface WhoWillEnrollContentModel {
	administratorOnlyLabel: string;
	administratorOnlyDescription: string;
	memberOptionText: string;
	adminOptionText: string;
	whoWillEnrollPageTitle: string;
	whoWillEnrollPageSubTitle: string;
	whoWillEnrollPageDescription: string;
	memberSelfEnrollLabel: string;
	memberSelfEnrollHelperTexts: string;
	retirementPlanLabel?: string;
	medicalPlanLabel: string;
	dentalPlanLabel: string;
	disabilityPlanLabel: string;
	stdPlanLabel: string;
	ltdPlanLabel: string;
	memberSelfEnrollAddtionalHelperTexts: string;
	adminEnrollBehalfOfMemberLabel: string;
	goBackButtonText: string;
	continueButtonText: string;
	continueHelperText: string;
	enrollmentTypeLabel: string;
	gpsType: GpsType;
	hideBack?: boolean;
	initialSuccessMessage?: string;
}